var CITIZENS_ROUTING_NOS = [
    ['211170114', 'Connecticut'],
    ['031101143', 'Delaware'],
    ['211070175', 'Massachusetts'],
    ['241070417', 'Michigan'],
    ['011401533', 'New Hampshire'],
    ['036076150', 'New Jersey'],
    ['021313103', 'New York'],
    ['241070417', 'Ohio'],
    ['036076150', 'Pennsylvania'],
    ['011500120', 'Rhode Island'],
    ['021313103', 'Vermont'],
];
var SMART_BRANCH_DEMO_ROUTING_NOS = [
    ['039482920', 'New York'],
    ['204554927', 'New Jersey'],
    ['094765824', 'Ohio'],
];
export var WORKSPACE_TO_ROUTING_NOS_MAPPING = {
    Citizens: CITIZENS_ROUTING_NOS,
    'Smart Branch Testing': SMART_BRANCH_DEMO_ROUTING_NOS,
};
// This option will hide routing number field
export var WORKSPACE_TO_SINGLE_ROUTING_NO_MAPPING = {
    NinjaEdge: '091409746',
    'Kalsee CU': '272481855',
    AffinityFCU: '221283512',
};
// This option will prefill the routing number field with the value
export var WORKSPACE_TO_SINGLE_ROUTING_NO_MAPPING_PREFILLED_FIELD = {
    Y12: '264281432',
};
